import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, MenuItem, TextField, CircularProgress, Typography
} from '@mui/material';
import axios from 'axios';

const statusAluguelOptions = ['Reservado', 'Agendado', 'Ativo', 'Em Andamento', 'Finalizado', 'Cancelado', 'Atrasado', 'Análise'];
const statusPagamentoOptions = ['Pendente', 'Pago'];
const limpezaOptions = ['Lavado', 'Sujo'];

export default function StatusAluguelModal({ open, onClose, aluguel, onUpdate }) {
  const [statusAluguel, setStatusAluguel] = useState(aluguel.status_aluguel || '');
  const [statusPagamento, setStatusPagamento] = useState(aluguel.status_pagamento || '');
  const [limpeza, setLimpeza] = useState('Lavado'); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // ✅ Atualizar estados quando o aluguel mudar
  useEffect(() => {
    if (aluguel) {
      setStatusAluguel(aluguel.status_aluguel || '');
      setStatusPagamento(aluguel.status_pagamento || '');
      setError('');
    }
  }, [aluguel, open]);

  const handleSave = async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${process.env.REACT_APP_API_URL}/alugueis/${aluguel.id}/status`,
        {
          status_aluguel: statusAluguel,
          status_pagamento: statusPagamento,
          // Só envia limpeza se Finalizado e Pago
          ...(statusAluguel === 'Finalizado' && statusPagamento === 'Pago' ? { limpeza } : {})
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      onUpdate(statusAluguel, statusPagamento, limpeza);  
      onClose();   
    } catch (err) {
      console.error('Erro ao atualizar status:', err);
      setError('Erro ao atualizar status. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Atualizar Status do Aluguel</DialogTitle>
      <DialogContent>
        <TextField
          select
          fullWidth
          label="Status do Aluguel"
          value={statusAluguel}
          onChange={e => setStatusAluguel(e.target.value)}
          sx={{ mt: 2 }}
        >
          {statusAluguelOptions.map(status => (
            <MenuItem key={status} value={status}>{status}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          label="Status do Pagamento"
          value={statusPagamento}
          onChange={e => setStatusPagamento(e.target.value)}
          sx={{ mt: 2 }}
        >
          {statusPagamentoOptions.map(status => (
            <MenuItem key={status} value={status}>{status}</MenuItem>
          ))}
        </TextField>

        {/* Só mostra campo de limpeza ao finalizar e pagar */}
        {statusAluguel === 'Finalizado' && statusPagamento === 'Pago' && (
          <TextField
            select
            fullWidth
            label="Situação da Limpeza do Veículo"
            value={limpeza}
            onChange={e => setLimpeza(e.target.value)}
            sx={{ mt: 2 }}
          >
            {limpezaOptions.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
        )}

        {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Salvar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
